module.exports = __webpack_public_path__ + "static/media/linkedin.f2a93054.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/linkedin.svg
 ** module id = 1279
 ** module chunks = 0
 **/